  document.addEventListener('DOMContentLoaded', function () {

    if(window.innerWidth <= 989) {

      document.querySelectorAll('.vm_footer_title').forEach((button) => {

        button.addEventListener('click', function () {

          const parent = this.closest('.vm_footer_column');
          const content = parent.querySelector('.vm_footer_content');

          parent.classList.toggle('active');

          if(content.style.display === 'block') {
            content.style.display = 'none';
          } else {
            content.style.display = 'block';
          }

        });

      });

    }

    document.querySelectorAll('.vm_style_section_slider').forEach(function(slider){

        new Swiper(slider, {
            effect: "coverflow",
    grabCursor: !0,
    centeredSlides: !0,
    slidesPerView: "auto",
    coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 64,
        modifier: 2.4,
        slideShadows: !0
    },
    keyboard: {
        enabled: !0
    },
    mousewheel: {
        thresholdDelta: 70
    },
    spaceBetween: 0,
    loop: true,
    breakpoints: {
        360: {
            coverflowEffect: {
                stretch: 0,
                depth: 64,
                modifier: 2
            }
        },
        768: {
            spaceBetween: 0,
            coverflowEffect: {
                depth: 64,
                modifier: 2
            }
        },
      }
            
        });
      

    });

    $(document).on('click', '.js_open_below_tabs', function() {
      $('.js_tabs_coll').toggleClass('active');
    });


    $('.vm_trusted_by_slider').each(function() {

      $(this).slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 18000,
        cssEase: 'linear',
        arrows: false,
        dots: false,
        pauseOnHover: false,
        pauseOnFocus: false,

        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2.5
            }
          },
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });

    });

    if ($('.product_images').length > 0) {
        $('.product_images').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: $('.product_thumbs .image-slide').length > 4 ? '.product_thumbs': "",
            infinite: $('.product_thumbs .image-slide').length > 4 ? true : true,
            focusOnSelect: true,
            adaptiveHeight: true,
            swipeToSlide: true,
            draggable: true,
            touchThreshold: 100,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        dots: false
                    }
                }
            ]
        });
    }
    if ($('.product_thumbs').length > 0) {
        $('.product_thumbs').slick({
            slidesToShow: $('.product_thumbs .image-slide').length > 4 ? 4 : $('.product_thumbs .image-slide').length,
            // slidesPerRow: $('.product_thumbs .image-slide').length > 4 ? 4 : $('.product_thumbs .image-slide').length,
            slidesToScroll: 1,
            vertical: true,
            verticalSwiping: true,
            arrows: false,
            asNavFor: '.product_images',
            centerMode: false,
            focusOnSelect: true,
            draggable: true,
            infinite: $('.product_thumbs .image-slide').length > 4 ? true : true,
            adaptiveHeight: true,
            swipeToSlide: true,
            responsive: [
                {
                    breakpoint: 1201,
                    settings: {
                        dots: false,    
                        vertical: false,
                        verticalSwiping: false,
                        slidesToShow: $('.product_thumbs .image-slide').length > 4 ? 4 : $('.product_thumbs .image-slide').length
                    }
                },
                {
                  breakpoint: 600,
                  settings: {
                    dots: false,    
                    vertical: false,
                    verticalSwiping: false,
                    slidesToShow: 3
                  }
                }
            ]
        });
    }

    $('body').on("click", ".on_click_sizechart, .custom_size_chart_wrp .close_icon, .custom_size_chart .overlay", function (e) {
        $('.custom_size_chart:not(".js_custom_size_chart")').toggleClass('active');
        $('html').toggleClass('overflow-hidden');
    });
  
    
      function updateTrack() {
       if (document.querySelectorAll('.vm_price_slider_wrapper_desk').length) {

            document.querySelectorAll('.vm_price_slider_wrapper_desk').forEach(function(wrapper) {

              const minSlider = wrapper.querySelector('#lower');
              const maxSlider = wrapper.querySelector('#upper');
              const track = wrapper.querySelector('.slider-track');

              if (!minSlider || !maxSlider || !track) return;

              const min = parseInt(minSlider.min);
              const max = parseInt(minSlider.max);

              const left = ((minSlider.value - min) / (max - min)) * 100;
              const right = ((maxSlider.value - min) / (max - min)) * 100;

              track.style.background = `
                linear-gradient(
                  to right,
                  #d5d5d5 ${left}%,
                  #FFC4C3 ${left}%,
                  #FFC4C3 ${right}%,
                  #d5d5d5 ${right}%
                )
              `;
            });

          }
        }

        updateTrack();
        
      function updateTrack_mob() {
       if (document.querySelectorAll('.vm_price_slider_wrapper_mobile').length) {

            document.querySelectorAll('.vm_price_slider_wrapper_mobile').forEach(function(wrapper) {

              const minSlider = wrapper.querySelector('#lower_m');
              const maxSlider = wrapper.querySelector('#upper_m');
              const track = wrapper.querySelector('.slider-track');

              if (!minSlider || !maxSlider || !track) return;

              const min = parseInt(minSlider.min);
              const max = parseInt(minSlider.max);

              const left = ((minSlider.value - min) / (max - min)) * 100;
              const right = ((maxSlider.value - min) / (max - min)) * 100;

              track.style.background = `
                linear-gradient(
                  to right,
                  #d5d5d5 ${left}%,
                  #FFC4C3 ${left}%,
                  #FFC4C3 ${right}%,
                  #d5d5d5 ${right}%
                )
              `;
            });

          }
        }
      
        updateTrack_mob();

        try{


    
                
            var lowerSlider = document.querySelector('#lower'),
               upperSlider = document.querySelector('#upper'),
               lowerVal = parseInt(lowerSlider.value),
               upperVal = parseInt(upperSlider.value),
              lowerSlider_mob = document.querySelector('#lower_m'),
               upperSlider_mob = document.querySelector('#upper_m');


            upperSlider.oninput = function() {
               lowerVal = parseInt(lowerSlider.value);
               upperVal = parseInt(upperSlider.value);
               upperSlider.setAttribute('name', upperSlider.getAttribute('data-name'));
               if (upperVal < lowerVal + 4) {
                  lowerSlider.value = upperVal - 4;
                  lowerSlider_mob.value = upperVal - 4;

                  if (lowerVal == lowerSlider.min) {
                     upperSlider.value = 4;
                     upperSlider_mob.value = 4;
                  }
               }
              document.querySelector('input#Filter-Price-GTE').value=lowerVal+".00";
              document.querySelector('input#Filter-Price-LTE').value=upperVal+".00";
                document.querySelector('input#Mobile-Filter-Price-GTE').value=lowerVal+".00";
              document.querySelector('input#Mobile-Filter-Price-LTE').value=upperVal+".00";
              console.log(lowerVal+"testttt"+upperVal);
              updateTrack();
              updateTrack_mob();
            };

            lowerSlider.oninput = function() {
               lowerVal = parseInt(lowerSlider.value);
               upperVal = parseInt(upperSlider.value);
               lowerSlider.setAttribute('name', lowerSlider.getAttribute('data-name'));
               if (lowerVal > upperVal - 4) {
                  upperSlider.value = lowerVal + 4;
                  upperSlider_mob.value = lowerVal + 4;

                  if (upperVal == upperSlider.max) {
                     lowerSlider.value = parseInt(upperSlider.max) - 4;
                     lowerSlider_mob.value = parseInt(upperSlider.max) - 4;
                  }

               }
                document.querySelector('input#Filter-Price-GTE').value=lowerVal+".00";
              document.querySelector('input#Filter-Price-LTE').value=upperVal+".00";
                document.querySelector('input#Mobile-Filter-Price-GTE').value=lowerVal+".00";
              document.querySelector('input#Mobile-Filter-Price-LTE').value=upperVal+".00";
              console.log(lowerVal+"testttt"+upperVal);
              updateTrack();
              updateTrack_mob();
            };

            upperSlider_mob.oninput = function() {
               lowerVal = parseInt(lowerSlider_mob.value);
               upperVal = parseInt(upperSlider_mob.value);
               upperSlider_mob.setAttribute('name', upperSlider_mob.getAttribute('data-name'));
               if (upperVal < lowerVal + 4) {
                  lowerSlider.value = upperVal - 4;
                  lowerSlider_mob.value = upperVal - 4;

                  if (lowerVal == lowerSlider.min) {
                     upperSlider.value = 4;
                     upperSlider_mob.value = 4;
                  }
               }
              document.querySelector('input#Filter-Price-GTE').value=lowerVal+".00";
              document.querySelector('input#Filter-Price-LTE').value=upperVal+".00";
                document.querySelector('input#Mobile-Filter-Price-GTE').value=lowerVal+".00";
              document.querySelector('input#Mobile-Filter-Price-LTE').value=upperVal+".00";
              console.log(lowerVal+"testttt"+upperVal);
              updateTrack();
              updateTrack_mob();
            };

            lowerSlider_mob.oninput = function() {
               lowerVal = parseInt(lowerSlider_mob.value);
               upperVal = parseInt(upperSlider_mob.value);
               lowerSlider_mob.setAttribute('name', lowerSlider_mob.getAttribute('data-name'));
               if (lowerVal > upperVal - 4) {
                  upperSlider.value = lowerVal + 4;
                  upperSlider_mob.value = lowerVal + 4;

                  if (upperVal == upperSlider.max) {
                     lowerSlider.value = parseInt(upperSlider.max) - 4;
                     lowerSlider_mob.value = parseInt(upperSlider.max) - 4;
                  }

               }
                document.querySelector('input#Filter-Price-GTE').value=lowerVal+".00";
              document.querySelector('input#Filter-Price-LTE').value=upperVal+".00";
                document.querySelector('input#Mobile-Filter-Price-GTE').value=lowerVal+".00";
              document.querySelector('input#Mobile-Filter-Price-LTE').value=upperVal+".00";
              console.log(lowerVal+"testttt"+upperVal);
              updateTrack();
              updateTrack_mob();
            };

        }catch(er){

        }


            setTimeout(function(){
            $("body").on("click", "button.reset__button", function() {
                window.localStorage.href="/";
             });
              var title = document.querySelector('.shopify-policy__title h1')?.innerText;
      if (title == "Refund policy") {
         document.querySelector('.shopify-policy__title h1').innerText ="Returns and Refunds Ploicy";
      }
            }, 1500)
            var title = document.querySelector('.shopify-policy__title h1')?.innerText;
      if (title == "Refund policy") {
         document.querySelector('.shopify-policy__title h1').innerText ="Returns and Refunds Ploicy";
      }


      $('body').on("click", ".load_more--btn", function (e) {
        var products_on_page = $('.product-grid');
        $.ajax({
            url: $(this).attr('data-next_url'),
            method: 'GET',
            dataType: 'html'
        }).done(function (next_page) {
            var new_products = $(next_page).find('.product-grid');
            products_on_page.append(new_products.html());
            if($(next_page).find('.load_more--btn').length > 0) {
              $('.load_more--btn').attr("data-next_url", $(next_page).find('.load_more--btn').attr("data-next_url")); 
            } else { 
              $('.load_more--btn').hide(); 
            }
        });
    });


});